import React from 'react';
import i18n from '../../i18n';
import contryData from '../../constants/country.json';
import { otpRequest, verifyOtp } from '../../models/login';
import swal from 'sweetalert';
import ReCAPTCHA from 'react-google-recaptcha';
import Dropdown from 'react-bootstrap/Dropdown';
import WhatsAppIcon from '../common/icons';

const codeData = [...contryData];
export class LoginOtp extends React.Component {
  constructor() {
    super();
    this.state = {
      selected_country: {},
      isCaptchaVerified: false,
      captchaToken: '',
      input: {
        country_code: '+968',
      },
      is_otp_sent: false,
      t_c_acept: false,
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.sendOtp = this.sendOtp.bind(this);
    this.validateOtp = this.validateOtp.bind(this);
    this.handleCaptchaChange = this.handleCaptchaChange.bind(this);
  }

  componentDidMount() {
    var defaultCodeValue = this.getObjectByKeyValue(codeData, 'dial_code', '+968');
    this.setState({ selected_country: defaultCodeValue });
  }

  getObjectByKeyValue(jsonArray, key, value) {
    for (var i = 0; i < jsonArray.length; i++) {
      if (jsonArray[i][key] === value) {
        return jsonArray[i];
      }
    }
    return null;
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({
      input,
    });
  }

  handleCaptchaChange = (value) => {
    this.setState({
      isCaptchaVerified: true,
      captchaToken: value,
    });
    let { input } = this.state;
    input.captcha_token = value;
    this.setState({ input });
  };

  async sendOtp() {
    this.setState({ isOtpLoading: true });

    try {
      const response = await otpRequest(this.state.input);
      console.log(response, 'otp');

      if (response.success) {
        this.setState({ is_otp_sent: true });
      } else {
        swal(response.message, JSON.stringify(response.data), 'error');
      }
    } catch (error) {
      swal('Error', error.message || 'Something went wrong', 'error');
    } finally {
      // Set loading to false after request completes
      this.setState({ isOtpLoading: false });
    }
  }
  async validateOtp() {
    this.setState({ isLoading: true });

    try {
      const response = await verifyOtp(this.state.input);

      if (!response.success) {
        swal(response.message, response.data, 'error');
        return;
      }

      if ('token' in response.data) {
        swal(i18n.t('success'), response.message, 'success', {
          buttons: false,
          timer: 2000,
        })
          .then(() => {
            localStorage.setItem('is_logged_in', true);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem(
              'mzad_user_info',
              JSON.stringify({ ...response.data.user, token: response.data.token })
            );
            if (response.data.role === 'A') {
              window.location.href = '/dashboard';
            } else {
              window.location.href = '/';
            }
          })
          .catch((err) => {
            swal('Failed', err.message, 'error');
          });
      } else {
        swal(response.message, JSON.stringify(response.data), 'error');
      }
    } catch (error) {
      swal('Error', error.message || 'Something went wrong', 'error');
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    let selected_img =
      this.state.selected_country && this.state.selected_country.code
        ? this.state.selected_country.code.toLowerCase()
        : '';
    return (
      <React.Fragment>
        <div id="page-container-otp-login">
          <div className="divider"></div>
          <div className="content">
            <div className="main-container">
              <div className="container-header">
                <img src="./assets/images/login-icon.png" alt="login" />
                <span className="m-1">{i18n.t('login_using_otp')}</span>
              </div>
              <div className="inner-container">
                <div className="left-section">
                  <form id="login" className="card-body">
                    {!this.state.is_otp_sent && (
                      <div>
                        <div className="col-md-12">
                          <br></br>
                          <div style={{ width: '90%', margin: 'auto' }}>
                            <label for="Name">
                              <span className="text-black">*</span>
                              {i18n.t('phone_number')}
                            </label>
                          </div>
                          <br></br>
                          <div style={{ width: '90%', margin: 'auto' }}>
                            <Dropdown className="flag-dd">
                              <Dropdown.Toggle variant="country">
                                {this.state.selected_country && (
                                  <div>
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        '/images/flags/' +
                                        selected_img +
                                        '.svg'
                                      }
                                      alt=""
                                      style={{ width: '25px' }}
                                    />
                                    {/* {this.state.selected_country.label} */}
                                  </div>
                                )}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {codeData.map((item, i) => {
                                  let img = item.code.toLowerCase();
                                  return (
                                    <Dropdown.Item
                                      onClick={() => {
                                        this.setState((prev) => ({
                                          input: {
                                            ...prev.input,
                                            country_code: item.dial_code,
                                          },
                                          selected_country: item,
                                        }));
                                      }}
                                    >
                                      <img
                                        src={
                                          process.env.PUBLIC_URL + '/images/flags/' + img + '.svg'
                                        }
                                        alt=""
                                        style={{ width: '25px' }}
                                      />{' '}
                                      {item.label}
                                    </Dropdown.Item>
                                  );
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                            <input
                              type="text"
                              style={{ 'z-index': 0 }}
                              name="mobile"
                              value={this.state.input.mobile}
                              onChange={this.handleChange}
                              className="form-control custom-input rounded-pill mob-field"
                            />
                          </div>

                          <div className="text-danger text-justify">{this.state.errors.mobile}</div>
                        </div>

                        <div className="input-group input-group-sm mt-3">
                          <ReCAPTCHA
                            sitekey="6LceESUpAAAAAAC7C5FaMVWVBIdBRwWzMqR8Wvq7"
                            onChange={this.handleCaptchaChange}
                            className="m-auto recaptcha"
                            size="normal"
                            style={{
                              transform: 'scale(0.85)',
                              transformOrigin: '0 0',
                            }}
                          />
                        </div>

                        <div className="send-otp-on">
                          <span>{i18n.t('send_otp_on')}</span>
                          <div className="horizontal-line"></div>
                        </div>
                        <div className="buttons">
                          <button
                            type="button"
                            className="whatsapp-btn"
                            onClick={() => this.sendOtp()}
                            disabled={this.state.isOtpLoading} // disable while sending OTP
                          >
                            {this.state.isOtpLoading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm mr-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                {i18n.t('sending')}
                              </>
                            ) : (
                              <>
                                <WhatsAppIcon />
                                <span>{i18n.t('whatsapp')}</span>
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    )}

                    {this.state.is_otp_sent && (
                      <div className="col-md-12 m-auto">
                        <label>{i18n.t('enter_otp')}</label>
                        <div className="passwd">
                          <input
                            type="text"
                            name="otp"
                            value={this.state.input.otp}
                            onChange={this.handleChange}
                            className="form-control custom-input rounded-pill"
                          />
                        </div>
                        <hr />
                        <div className="submit">
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={this.validateOtp}
                            disabled={this.state.isLoading} // disable button while loading
                          >
                            {this.state.isLoading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm mr-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                {i18n.t('validating')}
                              </>
                            ) : (
                              i18n.t('verify_login')
                            )}
                          </button>
                        </div>
                      </div>
                    )}

                    {/* <div className="submit">
                      <Link to="/login" className="text-primary ms-1">
                        {i18n.t("login_using_email_user")}
                      </Link>
                    </div>

                    <p className="mb-2">
                      <Link to="/forgotPassword" className="text-info ms-1">
                        {i18n.t("forget_password")}
                      </Link>
                    </p>
                    <p className="text-dark mb-0">
                      {i18n.t("donthaveaccount")}
                      <Link to="/registration" className="text-dark ms-1">
                        {i18n.t("registration")}
                      </Link>
                    </p> */}
                  </form>
                </div>
                <div className="right-section d-none d-md-block">
                  <img src="./assets/images/1696936701627 1.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
